"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setProductThemePropsForPromiseViaComponent = exports.promiseViaComponent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _GuidHelper = require("./GuidHelper");

var _reactDom = require("react-dom");

var _ProductThemeProvider = _interopRequireDefault(require("../ProductThemeProvider/ProductThemeProvider"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var defaultOptions = function defaultOptions() {
  return {
    domNodeId: (0, _GuidHelper.generateGuid)(),
    doNotCloseOnPromiseResolution: false
  };
};
/**
 * Props to be passed into the ProductThemeProvider. Currently needed because it is rendered outside of the normal react tree.
 */


var productThemeProps = {};
/**
 * Helper for converting one off react components (like modals) into a functional promise based form.
 * Example Basic Usage:
 * const modalConfirmation = promiseViaComponent((close, resolve, reject, domNodeId) => <Modal onClose={close}> onSubmit{val => resolve(val)}); // Show a modal that can show a result.
 * modalConfirmation.then(value => alert(value)); // Show alert with submitted value.
 * @param reactRootElementFactory Function to create an element. Provided with two functions as arguments. One to close/remove the root element, and the other to resolve the result of the call for callers.
 * @param options
 * 		domNodeId Optional Dom Node root to create/use. If not provided a dynamic generic one will be used and the root will be appended on the body.
 * 		doNotCloseOnPromiseResolution If set does not automatically close modal on promise resolution.
 */

var promiseViaComponent = function promiseViaComponent(reactRootElementFactory) {
  var userOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var options = _objectSpread(_objectSpread({}, defaultOptions()), userOptions);

  var modalRoot = options.domNode || document.getElementById(options.domNodeId);

  if (modalRoot === null) {
    modalRoot = document.createElement("div");
    modalRoot["id"] = options.domNodeId;
    modalRoot.classList.add("modal-root");
    var commentNode = document.createComment("Created by mount in ReactHelper (Preamble)");
    document.body.appendChild(commentNode);
    document.body.appendChild(modalRoot);
    modalRoot = document.getElementById(options.domNodeId);
  }

  var close = function close() {
    return (0, _reactDom.unmountComponentAtNode)(modalRoot);
  };

  if (Object.keys(productThemeProps).length === 0) {
    // eslint-disable-next-line no-console
    console.warn("You are using promiseViaComponent, but have not set any productThemeProps via the setProductThemePropsForPromiseViaComponent function. The component will be rendered using the default theme.");
  }

  return new Promise(function (resolve, reject) {
    var resultWrapperFor = function resultWrapperFor(fn) {
      return options.doNotCloseOnPromiseResolution ? fn : function () {
        // eslint-disable-next-line prefer-rest-params
        fn.apply({}, arguments);
        close();
      };
    };

    var resolveWrapper = resultWrapperFor(resolve);
    var rejectWrapper = resultWrapperFor(reject);
    (0, _reactDom.render)( /*#__PURE__*/_react.default.createElement(_ProductThemeProvider.default, productThemeProps, reactRootElementFactory(close, resolveWrapper, rejectWrapper, options.domNodeId)), modalRoot);
  });
};
/**
 * Used to set the props that will be passed into the ProductThemeProvider
 * @param {} props
 */


exports.promiseViaComponent = promiseViaComponent;

var setProductThemePropsForPromiseViaComponent = function setProductThemePropsForPromiseViaComponent(props) {
  productThemeProps = props;
};

exports.setProductThemePropsForPromiseViaComponent = setProductThemePropsForPromiseViaComponent;